import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule, Routes} from '@angular/router';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {NgxSliderModule} from '@angular-slider/ngx-slider';
import {MatSelectModule} from '@angular/material/select';
import {MatInputModule} from '@angular/material/input';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatTooltipModule} from '@angular/material/tooltip';
import {DirectiveModule} from '~/app/shared/directives/directive.module';
import {SaveComponent} from './popup/save/save.component';
import {MatDialogModule} from '@angular/material/dialog';
import {MatMenuModule} from '@angular/material/menu';
import {AlertComponent} from './popup/alert/alert.component';
import {MatRadioModule} from '@angular/material/radio';
import {FiltersComponent} from './filters/filters.component';
import {FiltersCityComponent} from './filters-city/filters-city.component';
import {ResultsCityComponent} from './results-city/results-city.component';
import {ResultsComponent} from './results/results.component';
import {MessagesModule} from '@components/messages/messages.module';
import {SaveCityComponent} from './popup/save-city/save-city.component';
import {JoyrideModule} from 'ngx-joyride';
import {PubSaveComponent} from './popup/pub-save/pub-save.component';
import {PubOpenComponent} from './popup/pub-open/pub-open.component';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {FavoriteModule} from '@components/favorite/favorite.module';
import {PreviewPopupComponent} from './results/preview-popup/preview-popup.component';
import {WidgetModule} from '@components/widget/widget.module';
import {Nl2BrPipeModule} from 'nl2br-pipe';
import {EditComponent} from './popup/edit/edit.component';
import {DuplicateComponent} from '@module/search/popup/duplicate/duplicate.component';
import { AlertConfirmComponent } from './popup/alert-confirm/alert-confirm.component';
import { AlertHsComponent } from './popup/alert-hs/alert-hs.component';
import { NewComponent } from './new/new.component';
import { NewCityComponent } from './new-city/new-city.component';
import { EditCityComponent } from './popup/edit-city/edit-city.component';
import { DupplicateCityComponent } from './popup/dupplicate-city/dupplicate-city.component';

export const UserRoutes: Routes = [
    {path: 'search/:id/filters', component: FiltersComponent},
    {path: 'search/:id', component: ResultsComponent},
    {path: 'search', component: NewComponent},
    // Pas de reset des filtres : le secteur en cours est conservé (le « + Nouveau
    // secteur » du sélecteur gère lui-même la remise à zéro)
    // Comme « Recherche » (NewComponent) : entrer par le menu réinitialise les filtres
    {path: 'city', component: NewCityComponent},
    {path: 'city/:id/filters', component: FiltersCityComponent},
    {path: 'city/:id', component: ResultsCityComponent},
];

@NgModule({
    declarations: [SaveComponent, AlertComponent, FiltersComponent, FiltersCityComponent, ResultsCityComponent, ResultsComponent, SaveCityComponent, PubSaveComponent, PubOpenComponent, PreviewPopupComponent, EditComponent, DuplicateComponent, AlertConfirmComponent, AlertHsComponent, NewComponent, NewCityComponent, EditCityComponent, DupplicateCityComponent],
    imports: [
        CommonModule,
        RouterModule.forChild(UserRoutes),
        ReactiveFormsModule,
        FormsModule,
        MatFormFieldModule,
        MatProgressSpinnerModule,
        NgxSliderModule,
        MatSelectModule,
        MatFormFieldModule,
        MatInputModule,
        MatRadioModule,
        MatCheckboxModule,
        MatAutocompleteModule,
        MatTooltipModule,
        DirectiveModule,
        MatDialogModule,
        MatMenuModule,
        MessagesModule,
        JoyrideModule,
        MatButtonToggleModule,
        FavoriteModule,
        WidgetModule,
        Nl2BrPipeModule,
    ]
})
export class SearchModule {
}
